import { createContext, useContext, useState, useCallback } from "react";
import { BookingModal } from "../components/BookingModal";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, therapistSlug: null, massageSlug: null });

  const openBooking = useCallback((pre = {}) => {
    setState({
      open: true,
      therapistSlug: pre.therapistSlug || null,
      massageSlug: pre.massageSlug || null,
    });
  }, []);

  const setOpen = useCallback((open) => setState((s) => ({ ...s, open })), []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <BookingModal state={state} setOpen={setOpen} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
